
import EcomMyInput from '@/components/ui/EcomMyInput.vue';
import MyCheckbox from '@/components/ui/MyCheckbox.vue';
import { email, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import recaptcha from '~/mixins/recaptcha';
import dynamicModal from '~/mixins/dynamicModal';
import { NEWSLETTER } from '~/consts/modals';

export default {
    name: 'EcomSubscription',
    mixins: [recaptcha, dynamicModal],
    components: { MyCheckbox, EcomMyInput },
    data() {
        return {
            email: '',
            terms: false,
            getSubmited: false,
            successSend: false,
            failSend: false,
            errorData: null,
            timeout: null,
            dynamicModalName: NEWSLETTER
        };
    },
    watch: {
        $route() {
            this.resetFields();
        }
    },
    computed: {
        ...mapGetters({
            isCasaDelTabaco: 'global/getIsCasaDelTabaco'
        }),

        emailErrorText() {
            return this.failSend ? (this?.errorData ? this.errorData : this.$t('subscribeError')) : this.$t('required');
        },
        emailValidation() {
            return this.failSend || (this.getSubmited && this.$v.email.$invalid);
        }
    },
    methods: {
        resetFields() {
            this.email = '';
            this.terms = false;
            this.getSubmited = false;

            this.resetCaptchaPass();
        },
        async subscriptionFormHandler() {
            this.$v.$touch();
            this.getSubmited = true;

            try {
                if (!this.$v.$invalid && this.terms && !this.invalidCaptchaPass(this.getSubmited)) {
                    const response = await this.$axios.post('/settings/news-letter/', {
                        email: this.email
                    });

                    if (response.status === 201) {
                        this.successSend = true;
                        this.resetFields();

                        setTimeout(() => {
                            this.successSend = false;
                        }, 5000);
                    }

                    this.resetCaptchaPass();
                }
            } catch (error) {
                if (error.response?.data?.error) {
                    this.failSend = true;
                    this.errorData = error.response?.data?.error;
                }

                this.getSubmited = false;
                console.error(error);
            }
        },
        checkboxHandler(value) {
            this.terms = !value;
        }
    },
    validations: {
        email: {
            required,
            email
        },
        terms: { required }
    }
};
